export const BuildInfo = {timestamp:1780702189000}
